import http from '@/utils/Http'

const searchState = () => {
    return {
        current_page: 1,
        per_page: 0,
        total_entries: 0,
        entries: []
    }
};

const BASE_PATH = '/v1/broker_customers_wallets';

const loadEntries = (path) => {
    return new Promise((resolve, reject) => {
        http.get(path)
            .then(({data}) => resolve(data))
            .catch(reject);
    })
};

export default {
    namespaced: true,
    state: {
        search: searchState(),
        brokers: [],

    },
    getters: {
        search(state) {
            return state.search;
        },
        brokers: state => state.brokers,
    },
    mutations: {
        resetSearch(state, defaultValues = {}) {
            state.search = Object.assign({}, searchState(), defaultValues);
        },
        setSearch(state, payload) {
            state.search = payload;
        },
        setBrokers(state, payload) {
            state.brokers = payload
        }
    },
    actions: {
        async filter({commit, state}, path) {
            return new Promise((resolve, reject) => {
                loadEntries(path)
                    .then(data => {
                        commit('setSearch', Object.assign({}, state.search, data));
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async loadMore({}, path) {
            return loadEntries(path);
        },
        async resetSearch({commit}, defaultValues = {}) {
            commit('resetSearch', defaultValues);
        },
        async destroy({commit}, id) {
            return new Promise((resolve, reject) => {
                http.delete(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async load({commit}, id) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async loadBrokers({commit}) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/load_brokers`)
                    .then(({data}) => {
                        commit('setBrokers', data);
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async save({commit}, payload) {
            return new Promise((resolve, reject) => {
                if(payload.id) {
                    http.put(`${BASE_PATH}/${payload.id}`, {product: payload})
                        .then(({data}) => resolve(data))

                        .catch(err => reject(err));
                } else {
                    http.post(BASE_PATH, {product: payload})
                        .then(({data}) => resolve(data))
                        .catch(err => reject(err));
                }
            })
        },
    }
}
